import React from 'react';
import PropTypes from 'prop-types';

const headerStyles = {
  width: '100%',
  height: 80,
  paddingLeft: 'calc(50vw - 670px)',
  paddingRight: 'calc(50vw - 670px)',
  paddingTop: '20px',
  background: '#FFF',
  borderBottom: '1px solid #e8e8eb',
};

const campaignTitleStyle = {
  padding: '0px 20px',
};

const CampaignDashboardHeader = props => {
  const {
    name,
  } = props;
  return (
    <div style={headerStyles}>
      <h2 style={campaignTitleStyle}>
        {name}
      </h2>
    </div>
  );
};

CampaignDashboardHeader.propTypes = {
  name: PropTypes.string.isRequired,
};

export default CampaignDashboardHeader;



/** WEBPACK FOOTER **
 ** ./src/components/campaign-dashboard-header/index.js
 **/